import React from "react";

const Playground = () => {
  return <p>Hello</p>;
};

export default Playground;
